import { useSelector } from 'react-redux'
import { createPortal } from 'react-dom'
import { Fragment } from 'react'

const ProgressBar = () => {
  const progress = useSelector(state => state.ad.progressBar.current)
  return (
    progress &&
    createPortal(
      <div className="ad_progress">
        <strong className="screen_out">광고만들기 단계</strong>
        <div className="info_step">
          {progress.map((item, index) => (
            <Fragment key={`step${index + 1}`}>
              <span
                className={`desc_step${item.active ? ' on' : ''}${
                  item.done ? ' end' : ''
                }`}>
                <span className="step_num">{index + 1}</span>
                {item.text}
              </span>
              {index < progress.length - 1 && <span className="step_line" />}
            </Fragment>
          ))}
        </div>
      </div>,
      document.getElementById('kakaoHead')
    )
  )
}

export default ProgressBar
